import { createActions } from 'redux-actions';

const { search, searchIdle, searchSuccess, searchFailure, loadMore, loadMoreIdle, loadMoreSuccess, loadMoreFailure } = createActions(
  'SEARCH',
  'SEARCH_IDLE',
  'SEARCH_SUCCESS',
  'SEARCH_FAILURE',
  'LOAD_MORE',
  'LOAD_MORE_IDLE',
  'LOAD_MORE_SUCCESS',
  'LOAD_MORE_FAILURE'
);

export { search, searchIdle, searchSuccess, searchFailure, loadMore, loadMoreIdle, loadMoreSuccess, loadMoreFailure };